// extracted by mini-css-extract-plugin
module.exports = {"skill":"Skill_skill__1GGHZ","overlay":"Skill_overlay__3c9R2","deactivated":"Skill_deactivated__2K-4j","recharging":"Skill_recharging__3XBCf","icon":"Skill_icon__3TDwO"};